import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Link from '@/lib/compat/link';
import { useTranslations } from '@/lib/i18n/client';

export function AccessDenied() {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 text-center px-4">
      <ShieldX className="w-16 h-16 text-muted-foreground/40" />
      <h1 className="text-2xl font-bold text-foreground">
        {t('permissions.accessDenied')}
      </h1>
      <p className="text-muted-foreground max-w-md">
        {t('permissions.accessDeniedDescription')}
      </p>
      <Button asChild className="mt-2">
        <Link href="/">{t('permissions.goHome')}</Link>
      </Button>
    </div>
  );
}
